import { useEffect, useState } from 'react';
import { breakpoints } from '@/styles/breakpoints';

const getMatches = (query: string) =>
    typeof window !== 'undefined' && window.matchMedia(query).matches;

export const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState(() => getMatches(query));

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query);
        const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);

        setMatches(mediaQueryList.matches);
        mediaQueryList.addEventListener('change', onChange);
        return () => mediaQueryList.removeEventListener('change', onChange);
    }, [query]);

    return matches;
};

/** True on phone-sized viewports (≤767px). */
export const useIsPhone = () => useMediaQuery(`(max-width: ${breakpoints.phone}px)`);

/** True on phone and tablet viewports (≤1024px), i.e. anything below desktop. */
export const useIsUpToTablet = () => useMediaQuery(`(max-width: ${breakpoints.tablet}px)`);
